import {
    collection,
    addDoc,
    deleteDoc,
    doc,
    getDocs
  } from 'firebase/firestore';
import { database } from './firebase.js';

import { API_BASE_URL } from '../config';

export async function getChildren(managerId, includeCounter = false) {
    let savedUser = JSON.parse(localStorage.getItem('user'));
    console.log(savedUser["jwtToken"]);
    return fetch(`${API_BASE_URL}/api/v1/manager/children/${managerId}`,{headers:{"Authorization":`Bearer ${savedUser["jwtToken"]}`}})
        .then((response) => {
            if(response.status==401 || response.status==403) {
              localStorage.removeItem('user');
              localStorage.setItem('isLoggedIn',false);
              window.location.reload();
            }
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.json();
        })
        .then((data) => {
            if (includeCounter) {
                const employeesWithCounter = data.map((employee, index) => ({
                    ...employee,
                    counter: index + 1,
                }));
                return employeesWithCounter;
            }
            return data;
        })
        .catch((error) => {
            console.error(error);
        }
    );
}

export async function getEmployee(employeeId) {
  let savedUser = JSON.parse(localStorage.getItem('user'));
    return fetch(`${API_BASE_URL}/api/v1/child/${employeeId}`,{headers:{"Authorization":`Bearer ${savedUser["jwtToken"]}`}})
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .catch((error) => {
        console.error(error);
      }
    );
}
  
  export async function updateEmployee(employeeId, updatedEmployee) {
    let savedUser = JSON.parse(localStorage.getItem('user'));
    return fetch(`${API_BASE_URL}/api/v1/child/update/${employeeId}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "Authorization":`Bearer ${savedUser["jwtToken"]}`,
      },
      body: JSON.stringify(updatedEmployee),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .catch((error) => {
        console.error(error);
      }
    );
}

export async function createEmployee(formData) {
  let savedUser = JSON.parse(localStorage.getItem('user'));
    return fetch(`${API_BASE_URL}/api/v1/child/create`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        "Authorization":`Bearer ${savedUser["jwtToken"]}`,
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .catch((error) => {
        console.error(error);
      }
    );
}

export async function deleteEmployee(employeeId) {
  let savedUser = JSON.parse(localStorage.getItem('user'));
  return fetch(`${API_BASE_URL}/api/v1/child/${employeeId}`, {
      method: 'DELETE',
      headers: {
          'Content-Type': 'application/json',
          "Authorization":`Bearer ${savedUser["jwtToken"]}`,
      },
  })
  .then((response) => {
      if (!response.ok) {
          throw new Error('Network response was not ok');
      }
      return response.text().then((text) => {
          return text ? JSON.parse(text) : {};
      });
  })
  .catch((error) => {
      console.error('Error:', error);
  });
}

export async function getPhotos() {
  const photoCollection = collection(database, 'task_photos');
  const photosSnapshot = await getDocs(photoCollection);
  const photos = [];
  photosSnapshot.forEach((doc) => {
    photos.push({ id: doc.id, ...doc.data() });
  });
  return photos;
}

export async function getMaterials() {
    const materialsCollection = collection(database, 'materials');
    const materialsSnapshot = await getDocs(materialsCollection);
    const materials = [];
    materialsSnapshot.forEach((doc) => {
        materials.push({ id: doc.id, ...doc.data() });
    });
    return materials;
}

export async function deleteMaterial(id){
    const materialDocRef = doc(database, 'materials', id);
    await deleteDoc(materialDocRef);
}

export async function saveMaterial(name, fileType, url, createdAt) {
    try {
        const materialData = {
            name: name,
            contentType: fileType,
            downloadURL: url,
            created: createdAt,
        };
    
        const docRef = await addDoc(collection(database, 'materials'), materialData);
        console.log('Material added with ID: ', docRef.id);
    } 
    catch (error) {
        console.error('Error adding material: ', error);
    }
}

export async function updateUser(updatedUser) {
  let savedUser = JSON.parse(localStorage.getItem('user'));
    return fetch(`${API_BASE_URL}/api/v1/manager/${updatedUser.id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "Authorization":`Bearer ${savedUser["jwtToken"]}`,
        },
        body: JSON.stringify(updatedUser),
        mode: 'cors',
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.json();
        })
        .catch((error) => {
          console.error(error);
        }
    );
}

export async function getAccountSettings(id) {
  let savedUser = JSON.parse(localStorage.getItem('user'));
  return fetch(`${API_BASE_URL}/api/v1/account/settings/${id}`,{headers:{"Authorization":`Bearer ${savedUser["jwtToken"]}`}})
      .then((response) => {
          if (!response.ok) {
              throw new Error('Network response was not ok');
          }
          return response.json();
      })
      .catch((error) => {
          console.error(error);
      });
}

export async function updateAccountSettings(id, updatedSettings) {
  let savedUser = JSON.parse(localStorage.getItem('user'));
  return fetch(`${API_BASE_URL}/api/v1/account/settings/${id}`, {
      method: 'PUT',
      headers: {
          'Content-Type': 'application/json',
          "Authorization":`Bearer ${savedUser["jwtToken"]}`,
      },
      body: JSON.stringify(updatedSettings),
  })
  .then((response) => {
      if (!response.ok) {
          throw new Error('Network response was not ok');
      }
      return response.json();
  })
  .catch((error) => {
      console.error(error);
  });
}

export async function getTasks(employeeId) {
  let savedUser = JSON.parse(localStorage.getItem('user'));
  return fetch(`${API_BASE_URL}/api/v1/task/${employeeId}`,{headers:{"Authorization":`Bearer ${savedUser["jwtToken"]}`}})
    .then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .catch((error) => {
      console.error(error);
    });
}

export async function deleteTask(taskId) {
  let savedUser = JSON.parse(localStorage.getItem('user'));
  return fetch(`${API_BASE_URL}/api/v1/task/${taskId}`, {
    method: 'DELETE',
  },{headers:{"Authorization":`Bearer ${savedUser["jwtToken"]}`}})
    .then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
    })
    .catch((error) => {
      console.error(error);
    });
}

export async function addSubTask(taskId, subTaskName) {
  let savedUser = JSON.parse(localStorage.getItem('user'));
  return fetch(`${API_BASE_URL}/api/v1/task/sub`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      "Authorization":`Bearer ${savedUser["jwtToken"]}`,
    },
    body: JSON.stringify({
      description: subTaskName,
      task: {
        id: taskId,
      },
    }),
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .catch((error) => {
      console.error(error);
    });
}

export async function deleteSubTask(subTaskId) {
  let savedUser = JSON.parse(localStorage.getItem('user'));
  return fetch(`${API_BASE_URL}/api/v1/task/sub/${subTaskId}`, {
    method: 'DELETE',
  },{headers:{"Authorization":`Bearer ${savedUser["jwtToken"]}`}})
    .then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
    })
    .catch((error) => {
      console.error(error);
    });
}

